/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-tablo-bord-favoris': {
    width: 78.4,
    height: 74.5,
    viewBox: '0 136 78.4 74.5',
    data: '<path pid="0" d="M63.4 210.5l-24.2-12.7L15 210.5l4.6-27-19.6-19 27.1-3.9L39.2 136l12.1 24.5 27.101 3.9L58.8 183.5l4.6 27zm-53-42.7l14.4 14-3.4 19.8 17.8-9.399L57 201.6l-3.4-19.8 14.4-14-19.9-2.8-8.9-18-8.9 18-19.9 2.8z"/>'
  }
})
